<template>
  <!-- 头部公用部分 -->
  <div>
    <div class="header">
      <div class="headAll cf">
        <div class="logo">
          <img src="../../assets/img/logo.png" alt="">
          {{title==='2'?'全国田径专业人员管理系统-成绩录入':'成绩证书打印'}}
        </div>
        <div class="logoTxt">
          <Menu mode="horizontal">
            <Submenu name="1">
              <template slot="title">
                <Icon type="ios-contact" />
                {{loginName}}
              </template>
              <MenuGroup>
                <MenuItem v-if="isPrint" name="1-2" @click.native="editModal=true">修改密码</MenuItem>
                <MenuItem v-if="isPrint" name="1-2" @click.native="userModal=true">修改用户信息</MenuItem>
                <MenuItem name="1-2" @click.native="loginOut()">退出登录</MenuItem>
              </MenuGroup>
            </Submenu>
          </Menu>
        </div>

      </div>
    </div>
    <!-- 修改密码模态框 -->
    <Modal v-model="editModal" title="修改密码" width="400" :footerHide="true">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">

        <FormItem label="旧密码" prop="oldPwd">
          <Input type="password" v-model="formValidate.oldPwd" placeholder="填写您的新密码"></Input>
        </FormItem>
        <FormItem label="新密码" prop="newPwd">
          <Input type="password" v-model="formValidate.newPwd" placeholder="填写您的新密码"></Input>
        </FormItem>
        <FormItem label="确认新密码" prop="confirmPassword">
          <Input type="password" placeholder="请再次输入密码" v-model="formValidate.confirmPassword"></Input>
        </FormItem>
        <div class="UpBut">
          <Button class="m-r10px" type="primary" size="large" :disabled="disableds" @click="editOk('formValidate')">保存</Button>
        </div>
      </Form>
    </Modal>
    <!-- 修改密码模态框 -->
    <Modal v-model="userModal" title="修改用户信息" width="400" :footerHide="true">
      <Form ref="userValidate" :model="userValidate" :rules="userRuleValidate" :label-width="80">
        <FormItem label="用户名：">
          <Input type="text" v-model="userValidate.username" disabled placeholder="填写您的用户名"></Input>
        </FormItem>
        <FormItem label="手机号码：" prop="mobile">
          <Input type="text" v-model="userValidate.mobile" placeholder="填写您的手机号码"></Input>
        </FormItem>
        <FormItem label="电子邮箱：" prop="email">
          <Input type="text" v-model="userValidate.email" placeholder="填写您的电子邮箱"></Input>
        </FormItem>
        <div class="UpBut">
          <Button class="m-r10px" type="primary" size="large" :disabled="disableds" @click="userEditOk('userValidate')">保存</Button>
        </div>
      </Form>
    </Modal>
  </div>
</template>

<script>
import { updateCurrPwd, updateCurrent } from "@/lib/api/";

export default {
  data() {
    // 验证二次输入密码
    const validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入您的新密码"));
      } else {
        if (this.formValidate.confirmPassword !== "") {
          // 对第二个密码框单独验证
          this.$refs.formValidate.validateField("confirmPassword");
        }
        callback();
      }
    };
    const validatePassCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再一次输入您的密码"));
      } else if (value !== this.formValidate.newPwd) {
        callback(new Error("两次密码不一致"));
      } else {
        callback();
      }
    };
    //验证手机
    const validatePhone = (rule, value, callback) => {
      let reg = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (value === "") {
        return callback();
      } else if (!reg.test(value)) {
        return callback(new Error("手机号格式不正确！"));
      } else {
        return callback();
      }
    };
    return {
      title: "",
      userModal: false,
      editModal: false,
      loading: false,
      disableds: false,
      loginName: "admin",
      unitData: [],
      formValidate: {
        oldPwd: "",
        newPwd: "",
        confirmPassword: "",
      },
      userValidate: {
        mobile: "",
        email: "",
      },
      userRuleValidate: {
        email: [
          { type: "email", message: "邮箱格式不正确！", trigger: "blur" },
        ],
        mobile: [{ validator: validatePhone, trigger: "blur" }],
      },
      ruleValidate: {
        oldPwd: [
          { validator: validatePass, trigger: "blur" },
          { type: "string", min: 6, message: "密码长度不能小于6位数" },
        ],
        newPwd: [
          { validator: validatePass, trigger: "blur" },
          { type: "string", min: 6, message: "密码长度不能小于6位数" },
        ],
        confirmPassword: [
          { validator: validatePassCheck, trigger: "blur" },
          { type: "string", min: 6, message: "密码长度不能小于6位数" },
        ],
      },
    };
  },
  components: {},
  computed: {
    isPrint() {
      return localStorage.authorities.indexOf(
        this.$PlugIn.role.roleAwardAdmin
      ) != -1
        ? false
        : true;
    },
  },
  methods: {
    editOk(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.disableds = true;
          let data = new FormData();
          data.append("newPwd", this.formValidate.newPwd);
          data.append("oldPwd", this.formValidate.oldPwd);

          updateCurrPwd(data).then(
            (res) => {
              if (res.data.code == 0) {
                this.$Message.info("修改成功");
                this.editModal = false;
                this.disableds = false;
                this.$refs[name].resetFields();
              } else if (res.data.code == -2) {
                this.$Message.error("修改失败");
              } else if (res.data.code == 10) {
                this.$Message.info("登录token过期请重新登录");
                this.$store.dispatch("loginOut");
              } else {
                this.$Message.error(res.data.msg);
              }
            },
            (err) => {
              this.$Message.error("网络连接失败");
            }
          );
        }
      });
    },
    userEditOk(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.disableds = true;
          let data = {
            mobile: this.userValidate.mobile,
            email: this.userValidate.email,
          };
          updateCurrent(data).then(
            (res) => {
              if (res.data.code == 0) {
                this.$Message.info("修改成功");
                this.userModal = false;
                this.disableds = false;
                this.$refs[name].resetFields();
              } else if (res.data.code == -2) {
                this.$Message.error("修改失败");
              } else if (res.data.code == 10) {
                this.$Message.info("登录token过期请重新登录");
                this.$store.dispatch("loginOut");
              } else {
                this.$Message.error(res.data.msg);
              }
            },
            (err) => {
              this.$Message.error("网络连接失败");
            }
          );
        }
      });
    },
    // 修改密码
    editPassword() {
      this.editModal = true;
    },
    //  退出登录
    loginOut() {
      if (localStorage.printGameid) {
        let gameid = localStorage.printGameid;
        let title = localStorage.printTi;

        localStorage.clear();
        
        localStorage.printGameid = gameid;
        localStorage.printTi = title;
        this.$router.push("/loginPrint");
      } else {
        localStorage.clear();
        this.$router.push("/gradeLogin");
      }
      location.reload();
    },
  },
  mounted() {
    //读取用户登录名
    this.loginName = localStorage.loginDataAll;
    this.userValidate = {
      mobile: localStorage.mobile ? localStorage.mobile : "",
      email: localStorage.email ? localStorage.email : "",
      username: this.loginName,
    };
    this.title = localStorage.titles;
  },
};
</script>

<style scoped lang="less">
.ivu-menu-light {
  background: none;
}
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu {
  color: #ffffff;
}
.ivu-menu-horizontal {
  height: 51px;
}
.heightAuto {
  height: auto;
}
.header {
  height: 90px;
  line-height: 90px;
  background-color: #4a98e2;
  .headAll {
    padding: 0px 20px;
    .heightAuto();
    margin: 0 auto;
    .logo {
      float: left;
      font-size: 20px;
      color: #fff;
      font-weight: bold;
      img {
        float: left;
        margin-right: 15px;
        width: 60px;
        margin-top: 13px;
      }
    }
    .passwordUp {
      padding-top: 4px;
      font-size: 14px;
      color: #fff;
      margin-right: 12px;
    }
    .logoTxt {
      float: right;
      font-size: 14px;
      color: #fff;
      line-height: 60px;
      position: relative;
      top: 18px;
    }
  }
}
.header .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu {
  border: none;
}

.header .ivu-menu-horizontal.ivu-menu-light:after,
.header .ivu-menu-horizontal.ivu-menu-light::before {
  height: 0 !important;
  position: static !important;
  width: 0 !important;
  background: none;
}
</style>



// WEBPACK FOOTER //
// src/public/header/index.vue